import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, isRef as _isRef, Teleport as _Teleport, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/pc/logo2.png'
import _imports_1 from '@/assets/images/contact_fb.png'
import _imports_2 from '@/assets/images/contact_tw.png'
import _imports_3 from '@/assets/images/contack_ins.png'
import _imports_4 from '@/assets/images/contact_bd.png'
import _imports_5 from '@/assets/images/contact_yt.png'
import _imports_6 from '@/assets/images/contack_eamil.png'


const _hoisted_1 = { class: "contact" }
const _hoisted_2 = { class: "contact_content" }
const _hoisted_3 = { id: "sel5" }
const _hoisted_4 = { class: "logo" }
const _hoisted_5 = { class: "email" }
const _hoisted_6 = { class: "url-box" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 1,
  href: "mailto://info@whales-entertainment.com",
  class: "url"
}
const _hoisted_9 = {
  key: 0,
  class: "protocol"
}
const _hoisted_10 = { class: "email_box" }
const _hoisted_11 = { class: "input_box" }
const _hoisted_12 = { class: "msgText" }
const _hoisted_13 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_14 = { class: "modal" }
const _hoisted_15 = { class: "modal-header" }
const _hoisted_16 = { class: "content" }

import {useRouter} from "vue-router";
import axios from "axios";

import {onMounted, reactive, ref} from "vue";
import { event } from 'vue-gtag'
import {addSubscription} from "@/api";




export default /*@__PURE__*/_defineComponent({
  __name: 'contact',
  props: {
  detail: {
    type: Object,
    default: () => ({
      email: 'info@whales-entertainment.com',   // 邮箱
      facebook_url: '',   // facebook 跳转链接
      discord_url: '',   // discord 跳转链接
    })
  }
},
  setup(__props) {

function isEmail(s) {
  return /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,4}){1,2})$/.test(s)
}
const router = useRouter();

const path = router.currentRoute.value.fullPath
const isShowAgreement =  (path == '/cascading-stars')

const props = __props
const detail = reactive<any>({
  email: '',   // 邮箱
  facebook_url: '',   // facebook 跳转链接
  discord_url: '',   // discord 跳转链接
})
onMounted(() => {
  initDetail()
})
const initDetail = () => {
  if(props.detail) {
    detail.email = (props.detail.email && props.detail.email.length > 0) ? props.detail.email : ''
    detail.facebook_url = (props.detail.facebook_url && props.detail.facebook_url.length > 0) ? props.detail.facebook_url : ''
    detail.discord_url = (props.detail.discord_url && props.detail.discord_url.length > 0) ? props.detail.discord_url : ''
  }
}

const jumpPage =  (path: string) => {
  router.push({
    path: path
  })
}

const JumpContack = (type: number) => {
  let url  = ''
  switch (type) {
    case 1:
      url =  detail.facebook_url.length > 0 ?  detail.facebook_url : 'https://www.facebook.com/people/Whales-Entertainment/100094886750896/'
      break;
    case 2:
      url = 'https://twitter.com/whalesentertain'
      break;
    case 3:
      url = 'https://www.instagram.com/whalesentertainment/'
      break;
    case 4:
      url = detail.discord_url.length > 0 ?  detail.discord_url : 'https://discord.gg/tBWdKjgCee'
      break;
    case 5:
      url = 'https://www.youtube.com/@WhalesEntertainment'
      break;
  }
  window.open(url)
}

const EmailVal = ref('')
const submitEmail = async () => {
  if (EmailVal.value.length == 0) {
    showFailed('Invalid! Please enter an email address.')
    return
  }
  if (!isEmail(EmailVal.value)) {
    showFailed('Invalid! Please enter correct email address')
    return
  }
  let jsStr = localStorage.getItem('ccenv2') || '{}'
  let ccenv = JSON.parse(jsStr)
  if (ccenv.ss !== undefined && new Date().getTime() - ccenv.ss < 1000 * 10) {
    showSucc()
    return
  }

  await addSubscription({
    "email": EmailVal.value,
  })
  EmailVal.value = ''
  msgText.value = ''
  showSucc()
  event('subscribe', {
    button_name: 'email_subscribe'
  });
  localStorage.setItem('ccenv2', JSON.stringify(JSON.parse('{"ss":' + new Date().getTime() + '}')))
  // axios.post("/api/subscribe/add", {
  //   "email": EmailVal.value,
  // }).then(rsp => {
  //   console.log(rsp)
  //   if (rsp.status == 200 && rsp.data['code'] == 0) {
  //     console.log('subscribe...OK')
  //
  //     return
  //   }
  //   showFailed('error')
  // })
}

const msgText = ref('')
let refShowModal = ref(false)
const showFailed = (msg: string) => {
  msgText.value = msg
  // showToast.value = true
  // setTimeout(() => {
  //   showToast.value = false
  // }, 2000)
  refShowModal.value = false
}
const showSucc = () => {
  refShowModal.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[15] || (_cache[15] = _createElementVNode("img", {
          src: _imports_0,
          alt: "",
          class: "company_logo"
        }, null, -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "contact_item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (JumpContack(1)))
          }, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("img", {
              src: _imports_1,
              alt: ""
            }, null, -1)
          ]))]),
          _createElementVNode("div", {
            class: "contact_item",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (JumpContack(2)))
          }, [...(_cache[10] || (_cache[10] = [
            _createElementVNode("img", {
              src: _imports_2,
              alt: ""
            }, null, -1)
          ]))]),
          _createElementVNode("div", {
            class: "contact_item",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (JumpContack(3)))
          }, [...(_cache[11] || (_cache[11] = [
            _createElementVNode("img", {
              src: _imports_3,
              alt: ""
            }, null, -1)
          ]))]),
          _createElementVNode("div", {
            class: "contact_item",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (JumpContack(4)))
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("img", {
              src: _imports_4,
              alt: ""
            }, null, -1)
          ]))]),
          _createElementVNode("div", {
            class: "contact_item",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (JumpContack(5)))
          }, [...(_cache[13] || (_cache[13] = [
            _createElementVNode("img", {
              src: _imports_5,
              alt: ""
            }, null, -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", _hoisted_6, [
            _cache[14] || (_cache[14] = _createElementVNode("img", {
              src: _imports_6,
              alt: "",
              class: "contack_eamil"
            }, null, -1)),
            (detail.email.length > 0)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: 'mailto://'+detail.email,
                  class: "url"
                }, _toDisplayString(detail.email), 9, _hoisted_7))
              : (_openBlock(), _createElementBlock("a", _hoisted_8, "info@whales-entertainment.com"))
          ])
        ]),
        isShowAgreement
          ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
              _createElementVNode("li", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (jumpPage('UserAgreement')))
              }, "User Agreement"),
              _createElementVNode("li", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (jumpPage('PrivacyPolicy')))
              }, "Privacy Policy")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "email_tips" }, " Subscribe for our monthly Newsletter! No spam. Unsubscribe at any time. ", -1)),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((EmailVal).value = $event)),
            placeholder: "Email Address"
          }, null, 512), [
            [_vModelText, EmailVal.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, _toDisplayString(msgText.value), 1),
        _createElementVNode("div", {
          class: "submit",
          onClick: submitEmail
        }, " Subscribe ")
      ])
    ]),
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "copyright" }, " © 2024-2025 Whales Entertainment. All Rights Reserved. ", -1)),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_unref(refShowModal))
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("header", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "title" }, " Almost Ready! ", -1)),
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "info" }, [
                    _createElementVNode("p", null, "We have sent you a message with a personal confirmation link."),
                    _createElementVNode("p", null, "Please check your email and follow the instructions found in our message.")
                  ], -1)),
                  _createElementVNode("div", {
                    class: "confirm_btn",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_isRef(refShowModal) //@ts-ignore
 ? refShowModal.value = false : refShowModal = false))
                  }, "CLOSE")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})